export default __webpack_public_path__ + "static/media/gs-4.e949c5eb.png";